import { Button } from "@/common/components/button";
import { AddFundWrapper } from "../subs/style";
import { useState } from "react";
import Form from "@/common/components/form/Form";
import { bankDetailsInput, cardDetailsInput } from "../data";

enum ITransferType {
  BANK = "bank_transfer",
  CARD = "card",
}

const AddFund = ({ pin }: { pin: () => void }) => {
  const [transferType, setTransferType] = useState<string | null>(null);
  return (
    <AddFundWrapper>
      <span className="radio-wrapper">
        <input
          type="radio"
          value="bank_transfer"
          name="transfer_type"
          id="transfer-type"
          checked={transferType === "bank_transfer"}
          onChange={(e) => setTransferType(e.target.value)}
        />
        <label htmlFor="transfer-type">Bank Transfer</label>
      </span>
      {transferType === ITransferType.BANK && (
        <div className="bank_details">
          <Form
            removeSubmitButton
            processInputs={() => alert("process")}
            formInputs={cardDetailsInput}
          />
          <h1 className="li-title">Payment Step</h1>
          <ul className="li">
            <li>Enter the amount you want to pay and click proceed.</li>
            <li>You will be given a temporary parkway transfer account.</li>
            <li>Transfer money to the account via online banking or USSD.</li>
          </ul>
        </div>
      )}
      <span className="radio-wrapper">
        <input
          type="radio"
          value="card"
          name="card"
          id="transfer-type"
          checked={transferType === "card"}
          onChange={(e) => setTransferType(e.target.value)}
        />
        <label htmlFor="transfer-type">Card</label>
      </span>
      {transferType === ITransferType.CARD && (
        <div className="bank_details">
          <Form
            removeSubmitButton
            processInputs={() => alert("process")}
            formInputs={bankDetailsInput}
          />
        </div>
      )}
      <Button onClick={pin}>Submit</Button>
    </AddFundWrapper>
  );
};

export default AddFund;
